import React from 'react'
import { BeatLoader } from 'react-spinners'

export default class LoaderDots extends React.Component {

  render() {
    return (
      <div>
        <BeatLoader sizeUnit={'px'} size={12} color={'#123abc'} />
      </div>
    )
  }
}
